<div class="avatar-circle avatar-circle--{{size}} avatar-circle--{{color}}">
    <ng-content></ng-content>
</div>